import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Divider,
  Container,
  Toolbar,
} from "@mui/material";
import { useAuth } from "../Context/authContext";
import Header from "../Components/header";
import Footer from "../Components/footer";
import AdminGeneralSettings from "../Components/Admin/adminGeneralSettings";
import AdminUnits from "../Components/Admin/adminUnits";
import AdminActivities from "../Components/Admin/adminActivities";
import AdminSubactivities from "../Components/Admin/adminSubactivities";
import AdminLogs from "../Components/Admin/adminLogs";
import AdminNotifications from "../Components/Admin/adminNotifications";

const AdminDashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  if (!user.userData.userRoles.includes("Administrator")) {
    return navigate("/");
  }

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      <Header></Header>
      <Toolbar sx={{ height: "120px" }} />
      <Container maxWidth="lg">
        <Typography variant="h4" gutterBottom>
          Administrator Dashboard
        </Typography>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
        >
          <Tab label="General Settings" />
          <Tab label="Notifications" />
          <Tab label="Units" />
          <Tab label="Activities" />
          <Tab label="Subactivities" />
          <Tab label="Logs" />
        </Tabs>
        <Divider sx={{ my: 2 }} />
        <Box>
          {activeTab === 0 && <AdminGeneralSettings />}
          {activeTab === 1 && <AdminNotifications />}
          {activeTab === 2 && <AdminUnits />}
          {activeTab === 3 && <AdminActivities />}
          {activeTab === 4 && <AdminSubactivities />}
          {activeTab === 5 && <AdminLogs />}
        </Box>
      </Container>
      <Footer></Footer>
    </Box>
  );
};

export default AdminDashboard;
